import { heroStats, tickerItems } from "@/mocks/anime";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50 pt-[68px]">
      <div className="pointer-events-none absolute -right-40 -top-40 h-[560px] w-[560px] rounded-full bg-accent-200/45 blur-3xl" />
      <div className="pointer-events-none absolute -left-40 top-40 h-[480px] w-[480px] rounded-full bg-primary-100/55 blur-3xl" />

      <div className="relative w-full px-4 pb-8 pt-8 md:px-8 md:pt-14">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14">
          <div className="animate-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full border border-accent-300 bg-accent-50 px-3.5 py-1.5 text-xs font-medium text-accent-900">
              <i className="ri-flashlight-fill" />
              在线观看 · 高清下载 · 追番排期 一站入口
            </span>

            <h1 className="mt-5 font-heading text-4xl leading-[1.15] text-foreground-950 md:text-5xl lg:text-6xl">
              51动漫：高清全集在线看，
              <br className="hidden md:block" />
              深夜追番与日常补番一站安排
            </h1>

            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              这里汇总 51动漫的高清资源与完整片库，覆盖当下热门连载与经典老番。无论你想
              <strong className="font-bold text-foreground-800">在线流畅观看</strong>
              ，还是先把整季
              <strong className="font-bold text-foreground-800">离线下载收藏</strong>
              ，都能在同一页里快速找到对应入口，省下逐集搜索的时间，把追番节奏握在自己手里。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#hot"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg" />
                进入在线观看入口
              </a>
              <a
                href="#download"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-accent-400 hover:text-accent-800 cursor-pointer"
              >
                <i className="ri-download-2-line text-lg" />
                查看资源下载专区
              </a>
            </div>

            <div className="mt-8 grid grid-cols-2 gap-4 border-t border-background-200 pt-6 sm:grid-cols-4">
              {heroStats.map((stat) => (
                <div key={stat.label}>
                  <div className="flex items-center gap-1.5 text-primary-600">
                    <i className={stat.icon} />
                    <span className="font-heading text-2xl text-foreground-950 md:text-3xl">
                      {stat.value}
                    </span>
                  </div>
                  <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative mx-auto w-full max-w-md lg:max-w-none">
            <div className="relative overflow-hidden rounded-lg border border-background-200 bg-background-100">
              <div className="aspect-[4/5] w-full">
                <img
                  src="https://readdy.ai/api/search-image?query=stylized%20anime%20key%20visual%20bright%20cozy%20room%20filled%20with%20stacked%20manga%20and%20glowing%20screens%20showing%20colorful%20scenes%20warm%20coral%20and%20amber%20lighting%20inviting%20atmosphere%20detailed%20illustration%20no%20text&width=900&height=1120&seq=anime-hero-keyvisual&orientation=portrait"
                  alt="51动漫 首页推荐视觉，堆满收藏与屏幕的温暖房间"
                  title="51动漫 高清在线观看与资源下载入口"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/80 to-transparent px-4 pb-4 pt-16">
                <p className="font-heading text-xl text-background-50">本周主推 · 星轨追想曲</p>
                <p className="mt-1 text-xs text-background-100/80">
                  科幻 / 恋爱 · 第 12 集已更新 · 1080P 可下载
                </p>
              </div>
            </div>

            <div className="absolute -left-3 top-6 hidden rounded-lg border border-background-200 bg-background-50 px-3.5 py-2.5 sm:block">
              <p className="text-[11px] text-foreground-500">在线播放稳定率</p>
              <p className="font-heading text-xl text-secondary-600">98%</p>
            </div>
            <div className="absolute -right-3 bottom-24 hidden rounded-lg border border-background-200 bg-background-50 px-3.5 py-2.5 sm:block">
              <p className="text-[11px] text-foreground-500">深夜更新值守</p>
              <p className="font-heading text-xl text-accent-700">7×24</p>
            </div>
          </div>
        </div>
      </div>

      <div className="relative w-full border-y border-background-200 bg-background-100 py-3">
        <div className="flex overflow-hidden">
          <div className="flex shrink-0 animate-marquee items-center gap-8 pr-8">
            {[...tickerItems, ...tickerItems].map((text, i) => (
              <span
                key={`${text}-${i}`}
                className="flex shrink-0 items-center gap-2 whitespace-nowrap text-xs text-foreground-600"
              >
                <i className="ri-notification-3-line text-primary-500" />
                {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}